import api from './api';

export interface User {
  id: string;
  name?: string;
  username?: string;
  first_name?: string;
  last_name?: string;
  email: string;
  empresa_id?: string | null;
  farmacia_id?: string | null;
  empresa?: Empresa | null;
}

export interface Empresa {
  id: string;
  nome_fantasia: string;
  razao_social: string;
  cnpj: string;
}

export interface LoginResponse {
  user: User;
  empresa?: Empresa | null;
  token?: string;
  access?: string;
}

export interface MeResponse {
  user: User;
  empresa: Empresa | null;
}

const authService = {
  async login(username: string, password: string): Promise<LoginResponse> {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('farmacia_id');
    localStorage.removeItem('empresa_id');

    const response = await api.post<LoginResponse>('/auth/login', {
      username,
      password,
    });
    
    const token = response.data.token || response.data.access;
    
    // Salvar token no localStorage
    if (token) {
      localStorage.setItem('auth_token', token);
    }

    const farmaciaId = response.data.empresa?.id || response.data.user?.empresa_id || response.data.user?.farmacia_id;
    if (farmaciaId) {
      localStorage.setItem('farmacia_id', farmaciaId);
      localStorage.setItem('empresa_id', farmaciaId);
    }
    
    return response.data;
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } finally {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('farmacia_id');
      localStorage.removeItem('empresa_id');
    }
  },

  async me(): Promise<MeResponse> {
    const response = await api.get<MeResponse>('/auth/me');
    const farmaciaId = response.data.empresa?.id || response.data.user?.empresa_id || response.data.user?.farmacia_id;
    if (farmaciaId) {
      localStorage.setItem('farmacia_id', farmaciaId);
      localStorage.setItem('empresa_id', farmaciaId);
    }
    return response.data;
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('auth_token');
  },

  getToken(): string | null {
    return localStorage.getItem('auth_token');
  },
};

export default authService;
